import { type Address } from "viem";

/**
 * Format an address to username (gross)
 */
export const formatAddressUsername = (address: Address, len = 6) => address.substring(2, len + 2);
